<template>
  <v-data-table
    fixed-header
    height="55vh"
    :headers="headers"
    :items="matchedsanctionsdata"
    :items-per-page="10"
    dense
  >
    <template v-slot:item.name="{ item }">
      <div v-html="formatNameHighlighters(item.name, highlightWord)"></div>
    </template>
    <template v-slot:item.dob="{ item }">
      {{ item.dob || "—" }}
    </template>
    <template v-slot:item.aka="{ item }">
      <div
        v-html="formatNameHighlighters(item.aka || '—', highlightWord)"
      ></div>
    </template>
    <template v-slot:item.address="{ item }">
      <div v-html="formatNameHighlighters(item.address, highlightWord)"></div>
    </template>
    <template v-slot:item.id_number="{ item }">
      {{ item.id_number || "—" }}
    </template>
    <template v-slot:item.id_type="{ item }">
      {{ item.id_type || "—" }}
    </template>
    <template v-slot:item.nationality="{ item }">
      {{ item.nationality || "—" }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "sanction Matched",
  data: () => ({
    highlightname: "",
    headers: [
      {
        text: "SDN.no",
        value: "ofacKey",
        sortable: false,
      },
      { text: "Name", value: "name", sortable: false },
      { text: "DOB", value: "dob", sortable: false },
      { text: "AKA", value: "aka", sortable: false },
      { text: "ID Number", value: "id_number", sortable: false },
      { text: "ID Type", value: "id_type", sortable: false },
      { text: "Nationality", value: "nationality", sortable: false },
      { text: "Address", value: "address", sortable: false },
      { text: "Type", value: "vessel_type", sortable: false },
      { text: "Remarks", value: "remarks", sortable: false },
    ],
  }),
  mounted() {
    this.highlightname = this.highlightWord;
  },
  methods: {
    formatNameHighlighters(val, highlightWord) {
      const wordsList = (Array.isArray(highlightWord) ? highlightWord : [])
        .filter((word) => typeof word === "string")
        .join(" ")
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
      if (val && wordsList.length > 0) {
        const regex = new RegExp(
          `(^|[^\\p{L}\\p{N}_])(${wordsList.join("|")})(?=$|[^\\p{L}\\p{N}_])`,
          "giu"
        );
        return val.replace(
          regex,
          (match, prefix, word) =>
            `${prefix}<mark><strong class="error--text">${word}</strong></mark>`
        );
      }
      return val;
    },
  },
  props: {
    matchedsanctionsdata: {
      type: Array,
    },
    highlightWord: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.bgprimary {
  background-color: $primary;
}
</style>
